define('bindingHandlers/tabbable',[
    'lib/knockout'
], function (ko) {
    'use strict';

    ko.bindingHandlers.tabbable = {
        update: function (element, valueAccessor) {
            var isTabbable = ko.unwrap(valueAccessor());
            element.tabIndex = isTabbable ? 0 : -1;
        }
    };
});
